import { getKindIcon, TECHDOCS_ICON } from '../../../../shared/constants';
import { Tile } from '../../../../shared/components';

interface SearchResultItemProps {
  title: string;
  subtitle?: string;
  text?: string;
  location: string;
  kind?: string;
  type?: string;
  onClick?: () => void;
}

export const SearchResultItem = ({
  title,
  subtitle,
  text,
  location,
  kind,
  type,
  onClick,
}: SearchResultItemProps) => {
  const Icon = type === 'techdocs' ? TECHDOCS_ICON : getKindIcon(kind);

  return (
    <Tile
      href={location}
      onClick={onClick}
      leading={<Icon size={18} />}
      title={title}
      subtitle={subtitle ?? kind}
      description={text}
    />
  );
};
